module.exports = __webpack_public_path__ + "static/media/logo_circles_white.1a6d96fa.svg";